function fullAudiences(audiences) {
	if (!audiences) return audiences;

	return audiences
		.map(audience => {
			switch (audience) {
				case 'for-myself':
					return { id: 'for-myself', title: 'For Myself' };
				case 'family-and-carers':
					return { id: 'family-and-carers', title: 'Family & Carers' };
				case 'for-healthcare-professionals':
					return { id: 'for-healthcare-professionals', title: 'For Healthcare Professionals' };
			}
		})
		.filter(audience => audience);
}

export { fullAudiences }


// WEBPACK FOOTER //
// ./src/managers/audienceManager.js